<template>
  <div class="header-frame">
    <div class="header">
      <div class="name"><strong>{{ content.profile.firstName }}</strong> {{ content.profile.lastName }}</div>

      <div class="menu desk">
        <div class="menu-items">
          <a class="menu-item" v-for="item in content.sections" :key="item.id" :href="'#'+item.id"><span>{{ item.label }}</span></a>
          <div class="menu-item download" v-if="withDownload" @click="openPdf"><i class="fa fa-file-pdf-o" aria-hidden="false"></i></div>
        </div>
      </div>

      <div class="menu mob">
        <div class="menu-picto" :class="{open: menu}" @click="showMenu"><i class="fa fa-bars fa-2x" aria-hidden="false"></i></div>
        <transition name="fade">
          <div class="menu-items" v-show="menu">
            <a class="menu-item" v-for="item in content.sections" :key="item.id" :href="'#'+item.id" @click="showMenu"><span>{{ item.label }}</span></a>
            <div class="menu-item download" v-if="withDownload" @click="openPdf"><span><i class="fa fa-file-pdf-o" aria-hidden="true" style="padding-right: 0.5rem;"></i>Télécharger</span></div>
          </div>
        </transition>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'header',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      menu: false,
      selectedId: ''
    }
  },
  methods: {
    openPdf () {
      window.open(this.pdf, '_blank')
    },
    showMenu () {
      this.menu = !this.menu
      if (this.menu) {
        window.addEventListener('click', this.clickOutListener, false)
        window.addEventListener('touchstart', this.clickOutListener, false)
      } else {
        window.removeEventListener('click', this.clickOutListener, false)
        window.removeEventListener('touchstart', this.clickOutListener, false)
      }
    },
    clickOutListener (e) {
      if (!this.$el.contains(e.target)) {
        this.menu = false
      }
    }
  },
  computed: {
    withDownload () {
      return this.content && this.content.profile && this.content.profile.pdf && this.content.profile.pdf.length > 0
    },
    pdf () {
      if (this.withDownload) {
        return this.content.profile.pdf
      }
      return ''
    }
  }
}
</script>

<style scoped>

.header-frame {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3.5rem;
  background-color: black;
  z-index: 3;
  color: white;
  padding-bottom: 1rem;
}

.header {
  max-width: 1024px;
  height: inherit;
  background-color: inherit;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.name {
  font-size: 2rem;
  padding-top: 1.5rem;
  padding-left: 2rem;
}

.name::before {
  content: "";
  border-top: 0.3rem solid white; /* #ff6a00; */
  width: 4rem;
  height: 2px;
  position: absolute;
  transform: translateY(2.5rem);
}

.menu {
  display: flex;
  flex-direction: row;
  padding-right: 1rem;
}

.menu-picto {
  color: white; /* #fd4900 */
  display: none;
  cursor: pointer;
}

.menu-items {
  display: flex;
  /* transition: border 0.25s linear; */
}

a.menu-item {
  color: white;
  text-decoration: none;
  border-bottom: 0.3rem solid transparent;
  /* transition: all .25s linear; */
  transition: border .25s linear, transform 0.25s linear, color 0.25s linear;
  margin: 0 1rem;
  cursor: pointer;
  padding-top: 2.125rem;
  padding-bottom: 0.5rem;
}

.menu-item:hover {
  border-color: #fd4900; /* #24E7E5; */
  transform: translateY(-0.5rem);
}

.menu-item.download {
  font-size: 1.2rem;
  padding-top: 2rem;
  cursor: pointer;
}

.menu-item.download:hover {
  color: #fd4900;
  border-bottom: 0.3rem solid transparent;
  transform: none;
}

.desk {
  display: block;
}

.mob {
  display: none;
}

@media screen and (max-width: 750px) {

  .desk {
    display: none;
  }

  .mob {
    display: block;
  }

  .menu {
    flex-direction: column;
    background-color: black;
    padding-right: 0;
  }

  .menu-items {
    flex-direction: column;
    background-color:  black;
    padding-right: 0;
    box-shadow: -1px 1px 3px 1px rgba(0,0,0,0.25);
    border-bottom: 1px solid #fd4900;
    position: absolute;
    right: 0;
  }

  .menu-item {
    background-color: black;
    margin: 0 0 !important;
    padding: 1rem 1rem !important;
    padding-left: 0.5rem !important;
    border-bottom: none !important;
    font-size: 1.2rem;
  }

  .menu-item span {
    border-left: 0.3rem solid transparent;
    padding-left: 0.5rem !important;
    margin: 1rem 2rem !important;
    margin-left: 0 !important;
    transition: border .25s linear;
  }

  .menu-item:hover {
    transform: translateX(0.5rem);
  }

  .menu-item:hover span {
    border-left: 0.3rem solid #fd4900;
  }

  .menu-item.download:hover span {
    border-left: 0.3rem solid transparent;
  }

  .menu-picto {
    display: block;
    align-self: flex-end;
    margin-top: 1.5rem;
    padding-right: 2rem;
    transition: color 0.25s linear;
    text-align: right;
    color: white;
  }

  .menu-picto.open {
    color: #fd4900;
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?69f29a2a